import { render, staticRenderFns } from "./selectPop.vue?vue&type=template&id=00507702&scoped=true"
import script from "./selectPop.vue?vue&type=script&lang=js"
export * from "./selectPop.vue?vue&type=script&lang=js"
import style0 from "./selectPop.vue?vue&type=style&index=0&id=00507702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00507702",
  null
  
)

export default component.exports